<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wjv6jg/tc-custom/9780062429735.jpg?1731153893485" alt="This image is the cover for the book Prophets of the Ghost Ants, The Antasy Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Prophets of the Ghost Ants, The Antasy Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Both familiar and fantastic, Clark T. Carlton begins the epic Antasy saga with <i>Prophets of the Ghost Ants, </i>exploring a world in which food, weapons, clothing, art—even religious beliefs—are derived from Humankind’s profound intertwining with the insect world.</b> </p><p>In a savage landscape where humans have evolved to the size of insects, they cannot hope to dominate. Ceaselessly, humans are stalked by night wasps, lair spiders, and marauder fleas. And just as sinister, men are still men. Corrupt elites ruthlessly enforce a rigid caste system. Duplicitous clergymen and power-mongering royalty wage pointless wars for their own glory. Fantasies of a better life and a better world serve only to torment those who dare to dream. </p><p>One so tormented is a half-breed slave named Anand, a dung-collector who has known nothing but squalor and abuse. Anand wants to lead his people against a genocidal army who fight atop fearsome, translucent Ghost Ants. But to his horror, Anand learns this merciless enemy is led by someone from his own family: a religious zealot bent on the conversion of all non-believers . . . or their extermination.</p><p>A mix of Adrian Tchaikovsky’s <i>Shadow of the Apt</i>,<i> </i>Katherine Addison’s <i>The Goblin Emperor</i>,<i> </i>and Phillip Pullman’s <i>Golden Compass</i>,<i> </i>this is a powerful new addition to the genre. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clark Thomas Carlton
      </h2>
      
      <p class="authorDescription body article"><P>Clark Thomas Carlton is an award-winning novelist, playwright, journalist, screen and television writer, and producer of reality TV. He was born in the South, grew up in the East, went to school in the North, and lives with his family in the West. As a child he spent hours observing ants and their wars and pondered their similarity to human societies.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cd08e50e